import React, { useState, useEffect } from "react";
import { findAllOrdersListBySellerEvent } from '../../../_events/pocket_balance/find_pocket_balance.event';
import { message } from "antd";
import PrimaryProgress from "../../../containers/progress/primary_progress";
import { DataGrid } from '@mui/x-data-grid';
import { withStyles } from "@mui/styles";
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Modal from '@mui/material/Modal';
import { buildDateTimeStr } from '../../../_utils/date_operations';
import { findAllOrderListLiveGroupByClientEvent } from "../../../_events/order_list_view/find.event";

const StyledDataGrid = withStyles({
    root: {
      "& .MuiDataGrid-renderingZone": {
        maxHeight: "none !important"
      },
      "& .MuiDataGrid-cell": {
        lineHeight: "unset !important",
        maxHeight: "none !important",
        whiteSpace: "normal"
      },
      "& .MuiDataGrid-row": {
        maxHeight: "none !important"
      }
    }
  })(DataGrid);


const Info = (props) => {

    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);

    const columns = [
        { field: 'name', headerName: 'Cliente', width: 200},
        { field: '', headerName: 'Ver', width: 100,
            renderCell: (params) => {
                return(<ModalInfo client={params.row.uuid} data={params.row.orders_list} />);
            }
        },
    ];

    const findData = () => {
        setLoading(true);
        findAllOrdersListBySellerEvent()
        .then(data => {
            setData(data.list);
            setLoading(false);
        })
        .catch(err => {
            message.error(err.message);
            setLoading(false);
        });
    };

    useEffect(() => {
        findData();
    }, []);   

    if(loading){
        return(
            <PrimaryProgress />
        );
    }
    else{
        return (
            <div style={{height: '500px', width: '100%'}}>
                <StyledDataGrid
                    rows={data}
                    columns={columns}
                    pageSize={100}
                    rowsPerPageOptions={[100]}
                    checkboxSelection={false}
                    getRowId={(p) => p.uuid}
                />
            </div>
        );
    }    
}

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '100%',
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 1,
  };

const ModalInfo = (props) => {

    const [open, setOpen] = React.useState(false);
    const [ data, setData ] = React.useState([]);

    const loadData = () => {
        findAllOrderListLiveGroupByClientEvent(props.client)
        .then(json => {
            setData(json.data?.detailsGroup);
        })
        .catch(err => {
            message.error(err.message);
        });
    }

    const handleOpen = () => {
        loadData();
        setOpen(true);     
    };

    const handleClose = () => {
        setData([]);
        setOpen(false);
    };

    return(
        <div>
            <Button variant='contained' size='small' onClick={handleOpen}>Ver</Button>
        <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box sx={style}>
            <div style={{display: 'flex', flexDirection: 'row', width: '100%'}}>
                <div style={{display: 'flex', flexDirection: 'column', width: '50%'}}>
                    <strong>
                        Estado de pedidos:
                    </strong>
                </div>                
                <div style={{display: 'flex', flexDirection: 'row-reverse', width: '50%'}}>
                    <Button size='small' onClick={handleClose}>Cerrar</Button>
                </div>
            </div>            
            {
               props.data.length === 0 ? (
                <>No hay reporte para este cliente</>
               ) : (
                <div style={{width: '100%'}}>
                    <div style={{width: '100%'}}>
                    <table style={{width: '100%'}}>
                        <thead style={{width: '100%'}}>
                            <tr>
                                <th style={{ width: '10%', fontSize: '0.5em', fontWeight: 'bold', border: '1px solid #000' }}>Pedido</th>
                                <th style={{ width: '15%', fontSize: '0.5em', fontWeight: 'bold', border: '1px solid #000' }}>Fecha</th>
                                <th style={{ width: '26%', fontSize: '0.5em', fontWeight: 'bold', border: '1px solid #000' }}>Descripción</th>
                                <th style={{ width: '13%', fontSize: '0.5em', fontWeight: 'bold', border: '1px solid #000' }}>Cantidad</th>
                                <th style={{ width: '13%', fontSize: '0.5em', fontWeight: 'bold', border: '1px solid #000' }}>Pendiente</th>
                                <th style={{ width: '13%', fontSize: '0.5em', fontWeight: 'bold', border: '1px solid #000' }}>Reservado</th>
                                <th style={{ width: '13%', fontSize: '0.5em', fontWeight: 'bold', border: '1px solid #000' }}>Despachado</th>
                            </tr>
                        </thead>
                    </table>
                    </div>
                    <div style={{width: '100%', overflowY: 'auto', height: '500px'}}>
                    {
                        data.map((d, key) => {
                            let date = d.date_created ? new Date(d.date_created) : null;
                            let dateRep = date ? `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}` : 'NA';
                            return(
                                <table key={`table_stateorder_seller_${key}`} style={{width: '100%'}}>
                                    <tbody style={{width: '100%'}}>
                                        <tr>
                                            <th style={{ width: '10%', fontSize: '0.5em', borderTop: '1px solid #000' }}>{`${d.order} OC:${d.purchase_order}`}</th>
                                            <th style={{ width: '15%', fontSize: '0.5em', borderTop: '1px solid #000' }}>{dateRep}</th>
                                            <th style={{ width: '26%', fontSize: '0.5em', borderTop: '1px solid #000' }}>{`${d.ref} Elástico ${d.color}`}</th>
                                            <th style={{ width: '13%', fontSize: '0.5em', borderTop: '1px solid #000' }}>{`${d.quantity}`}</th>
                                            <th style={{ width: '13%', fontSize: '0.5em', borderTop: '1px solid #000' }}>{`${d.pend}`}</th>
                                            <th style={{ width: '13%', fontSize: '0.5em', borderTop: '1px solid #000' }}>{`${d.reser}`}</th>
                                            <th style={{ width: '13%', fontSize: '0.5em', borderTop: '1px solid #000' }}>{`${d.despa}`}</th>
                                        </tr>
                                    </tbody>
                                </table>
                            )
                        })
                    }
                    </div>
                </div>
               )
            }
            </Box>
        </Modal>
        </div>
    );
}

export default Info;